import { render, staticRenderFns } from "./reCheckAssessmentPop.vue?vue&type=template&id=66b4b022"
import script from "./reCheckAssessmentPop.vue?vue&type=script&lang=js"
export * from "./reCheckAssessmentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b4b022')) {
      api.createRecord('66b4b022', component.options)
    } else {
      api.reload('66b4b022', component.options)
    }
    module.hot.accept("./reCheckAssessmentPop.vue?vue&type=template&id=66b4b022", function () {
      api.rerender('66b4b022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/reCheckAssessmentPop.vue"
export default component.exports